import { mapState } from 'vuex';

import AddressPicker from '~/components/address/AddressPicker.vue';
import IconMapMarkerAlt from '~/components/icon/IconMapMarkerAlt.vue';
import googleMapsLoader from '~/services/googleMapsLoader';
import formMixin from '~/services/form';
import { geocode } from '~/services/geocode';
import { requiredIf } from '~/services/validators';

export default {
    mixins: [formMixin],
    components: {
        AddressPicker,
        IconMapMarkerAlt,
    },
    data() {
        return {
            address: null,
            addressLine1: '',
            addressValidations: {
                address: [{ validator: requiredIf, field: 'addressLine1', value: '' }],
                addressLine1: [{ validator: requiredIf, field: 'address', value: null }],
                houseName: [],
                postcode: [{ validator: requiredIf, field: 'address', value: null }],
            },
            houseName: '',
            postcode: '',
            showAddAddress: !this.addresses?.length,
        };
    },
    created() {
        if (!this.$form && this.form) {
            this.$form = this.form;
        }
    },
    computed: {
        ...mapState('addresses', {
            addresses: (state) => state.data,
        }),
    },
    methods: {
        addAddressValidations() {
            this.$form.replaceValidations(this.addressValidations);
        },
        getAddressValidations() {
            return this.addressValidations;
        },
        async fetchLatLng(resolve) {
            let address = this.$form.address.$model;
            if (!address.lat) {
                address = await this.geocode();
                if (!address) {
                    resolve(false);
                    return;
                }
            }
            const response = await this.$axios.$post(this.$config.endpoints.address, address);
            this.$form.address.$model = response.address;
            this.$store.dispatch('addresses/add', response.address);
            this.$auth.fetchUser();
            resolve(response);
        },
        async geocode() {
            const address = this.$form.address.$model;
            const response = await geocode(`${address.address_1}, ${address.postcode}`);
            if (response) {
                if (!window.Cypress) {
                    address.lat = response.geometry.location.lat;
                    address.lon = response.geometry.location.lng;
                } else {
                    address.lat = 0;
                    address.lon = 0;
                }
                return address;
            }
            this.$form.$errorMessage = this.$t('addresses.not_recognised');
            return false;
        },
        submitAddress() {
            return new Promise((resolve) => {
                if (this.$form.address.$model.id) {
                    resolve(true);
                    return;
                }
                if (this.$form.validateFields(['address', 'addressLine1', 'postcode'])) {
                    if (this.$store.state.googleMaps.isReady) {
                        this.fetchLatLng(resolve);
                    } else {
                        googleMapsLoader(this.$store, () => {
                            this.fetchLatLng(resolve);
                        });
                    }
                } else {
                    resolve(true);
                }
            });
        },
        useAddress(address) {
            this.$form.address.$model = address;
        },
    },
};
